"use client";

import { RouteErrorView } from "@/components/error/route-error-view";
import { PublicConvexProvider } from "@/components/providers/public-convex-provider";

export function RootRouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <PublicConvexProvider>
      <RouteErrorView
        error={error}
        reset={reset}
        navigation={{ label: "Go to homepage", href: "/" }}
        containerClassName="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center px-6 py-12 text-center"
      />
    </PublicConvexProvider>
  );
}
